<template>
    <div class="credentialsCard">
        <div class="top">
            <div class="top-name">{{credentialsData.name}}</div>
            <div class="top-tips">
                <img src="@/assets/images/tips.png" alt="" class="top-tips-img">
                <div class="top-tips-text" @click="examples">点击查看示例</div>
            </div>
        </div>
        <div class="center"></div>
        <div :class="+credentialsData.key === 3 ? 'electronic_bottom' : 'bottom'">
            <div class="bottom-item">
                <div class="bottom-item-text">
                  <!-- {{credentialsData.frontText}}<span v-if="+credentialsData.key === 3" class="tip">请在12123刷新保证图片是最新时间</span> -->
                  {{credentialsData.frontText}}
                </div>
                <div :class="(((checkFrontOrBack == 'front' && grcCardMessage) || grcCardMessage) || ((checkDriverFrontOrBack == 'front' && grcDriverCardMessage) || grcDriverCardMessage)) || (((checkFrontOrBack == 'front' && ocrFail) || ocrFail) || ((checkDriverFrontOrBack == 'front' && ocrDriverFrontFail) || ocrDriverFrontFail)) || (ocrElectronicFail || electronicMessage)  ? 'credentialsCard_ocrFail': ''">
                  <Upload-img :upload="frontUpload" @base64Upload="base64Upload('front',$event)" @srcValue="srcValue('front',$event)" :checkFrontOrBack='checkFrontOrBack' :uploadCardFrontFail='uploadCardFrontFail' :uploadDriverFrontFail='uploadDriverFrontFail' :electronicKey="credentialsData.key" :credentialsData='credentialsData' :token='token'/>
                </div>
            </div>
            <div class="bottom-item" v-if="credentialsData.key != 3">
                <div class="bottom-item-text">{{credentialsData.backText}}</div>
                <div :class="(((checkFrontOrBack == 'back' && grcCardBackMessage) || grcCardBackMessage) || ((checkDriverFrontOrBack == 'back' && grcDriverBackCardkMessage) || grcDriverBackCardkMessage)) || (((checkFrontOrBack == 'back' && ocrCardBackFail) || ocrCardBackFail) || ((checkDriverFrontOrBack == 'back' && ocrDriverBackFail) || ocrDriverBackFail)) ? 'credentialsCard_ocrFail': ''">
                 <Upload-img :upload="backUpload" @base64Upload="base64Upload('back',$event)" @srcValue="srcValue('back',$event)" :checkFrontOrBack='checkFrontOrBack' :uploadCardBackFail='uploadCardBackFail'  :uploadDriverBackFail='uploadDriverBackFail' :credentialsData='credentialsData' :token='token'/>
                </div>
            </div>
        </div>
        <div v-if="showOcrSuccessOrFailText" 
        :class="(grcCardMessage || grcDriverCardMessage) || (grcCardBackMessage || grcDriverBackCardkMessage)  || ((ocrFail || ocrCardBackFail) || (ocrDriverFrontFail || ocrDriverBackFail) || ocrElectronicFail) ? 'card_tips card_tips_success' : 'card_tips'">
          <img v-if="(grcCardMessage || grcDriverCardMessage) || (grcCardBackMessage || grcDriverBackCardkMessage) || ((ocrDriverFrontFail || ocrDriverBackFail) || (ocrFail || ocrCardBackFail) || ocrElectronicFail) " src="../../../assets/images/nosaasfail.png"/>
          <img v-else  src="../../../assets/images/nosaas.png"/>
          {{ showTips ? showTips : ocrElectronicFail ? '识别失败，请上传原始截图或等待人工核验' : (ocrDriverFrontFail || ocrDriverBackFail) || (ocrFail || ocrCardBackFail) || ocrElectronicFail ? '识别失败，请重新上传或手动填写' : '以下信息为系统自动识别，如不正确请修改'}}
        </div>
        <div v-if="showOcrElectronicSuccessOrFailText" 
        :class="ocrElectronicFail || electronicStatus || electronicMessage ? 'card_tips card_tips_success' : 'card_tips'">
          <img v-if="ocrElectronicFail || electronicStatus || electronicMessage" src="../../../assets/images/nosaasfail.png"/>
          <img v-else  src="../../../assets/images/nosaas.png"/>
          {{ showTips ? showTips : electronicStatus ? '系统识别到您的驾驶证已扣12分，请处理销分后再入驻平台' : newelectronicMessage ? newelectronicMessage : ocrElectronicFail ? '识别失败，请上传原始截图或等待人工核验' : '证件识别成功' }}
        </div>
    </div>
</template>
<script>
import { handleBuryPoint } from "@/utils/tool.js";
// 身份证和驾驶证信息组件
import UploadImg from '@/pages/Home/components/UploadImg.vue'
import { axiosUploadExt } from '@/utils/uploadApi.js'
import { Toast } from 'vant';
export default {
  name: 'CredentialsCard',
  components:{ 
    UploadImg
  },
  props:{
    credentialsData:{
        type: Object,
        default: ()=>{
            return {
                
            }
        }
    },
    token:{
      type:String,
      default:''
    },
    ocrSuccess: {
      type:Boolean,
      default:false
    },
    ocrFail: {
      type:Boolean,
      default:false
    },
    ocrCardBackSuccess: {
      type: Boolean,
      default: false
    },
    ocrCardBackFail: {
      type: Boolean,
      default: false
    },
    checkFrontOrBack: {
      type: String,
      default: ''
    },
    // 以下为驾驶证信息
    ocrDriverFrontSuccess: {
      type:Boolean,
      default:false
    },
    ocrDriverFrontFail: {
      type:Boolean,
      default:false
    },
    ocrDriverBackSuccess: {
      type:Boolean,
      default:false
    },
    ocrDriverBackFail: {
      type:Boolean,
      default:false
    },
    checkDriverFrontOrBack: {
      type: String,
      default: ''
    },
    // grcCardMessage 230202 新增识别不合规身份证
    grcCardMessage: {
      type: String,
      default: ''
    },
    // grcDriverCardMessage 230202 新增识别不合规驾驶证
    grcDriverCardMessage: {
      type: String,
      default: ''
    },
    grcCardBackMessage: {
      type: String,
      default: ''
    },
    grcDriverBackCardkMessage: {
      type: String,
      default: ''
    },
    ocrElectronicSuccess: {
      type:Boolean,
      default: false
    },
    ocrElectronicFail: {
      type:Boolean,
      default: false
    },
    electronicMessage: {
      type: String,
      default: ''
    },
    electronicStatus: {
      type: Boolean,
      default: false
    },
    newelectronicMessage: {
      type: String,
      default: ''
    },
  },
  data() {
    return{
       uploadCardFrontFail: false,
       uploadCardBackFail: false,
       uploadDriverFrontFail: false,
       uploadDriverBackFail: false
    }
  },
  computed:{
    showTips() {
      return  (this.grcCardMessage || this.grcDriverCardMessage) || (this.grcCardBackMessage || this.grcDriverBackCardkMessage) || this.electronicMessage
    },
    // 正面证件上传图片
    frontUpload(){
      return{
        img:this.credentialsData.frontImg,
        baseImg:this.credentialsData.frontUrl,
      }
    },
    // 背面证件上传图片
    backUpload(){
      return{
        img:this.credentialsData.backImg,
        baseImg:this.credentialsData.backUrl,
      }
    },
    // 是否显示ocr识别成功或者失败文案
    showOcrSuccessOrFailText () {
      //   ocrSuccess 身份证正面识别成功   ocrCardBackSuccess 身份证背面识别成功
      //   ocrFail 身份证正面识别失败
      return (((this.ocrSuccess && this.ocrCardBackSuccess) || (this.ocrFail && this.ocrCardBackFail)) || (this.ocrSuccess ||  this.ocrFail) || (this.ocrCardBackSuccess ||  this.ocrCardBackFail)) || ((this.ocrDriverFrontSuccess && this.ocrDriverBackSuccess) || (this.ocrDriverFrontFail && this.ocrDriverBackFail)) || (this.ocrDriverFrontSuccess ||  this.ocrDriverFrontFail) || (this.ocrDriverBackSuccess ||  this.ocrDriverBackFail)
    },
    showOcrElectronicSuccessOrFailText () {
      return this.ocrElectronicFail || this.ocrElectronicSuccess
    }
  },
  mounted () {
    console.log(this.token, '4433344')
  },
  methods:{
      srcValue (key,obj) {
        this.$emit('srcValue',{
          ...obj,
          credentialsListKey: key,
        })
      },
      // 判断是否上传失败
      isUploadFail (type, key) {
        if (type == 1 && key== 'front') {
            this.uploadCardFrontFail = true
        } else if (type == 1 && key== 'back') {
            this.uploadCardBackFail = true
        } else if (type == 2 && key == 'front') {
            this.uploadDriverFrontFail = true
        } else if (type == 2 && key == 'back') {
            this.uploadDriverBackFail = true
        }
      },
      //查看示例
      examples(){
        const { examplesFrontUrl, examplesBackUrl, name, key } =this.credentialsData;
        if (key != 3) {
          this.$emit('examples',{
            examplesFrontUrl,
            examplesBackUrl,
            name
          })
        } else {
          this.$emit('examplesElectron')
        }
        if(name == '身份证') {
        handleBuryPoint('recruiting-Certificate', 'exampleIdCard_Click', {})
        }else{
        handleBuryPoint('recruiting-Certificate', 'exampleOfDrivingLicense_Click', {})
        }
      },
      // 使用base64上传图片
      base64Upload(key,strObj){
        const toastTips = Toast.loading({
            message: '上传中...',
            forbidClick: true,
        });
        const url = this.token?`/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false&token=${this.token}&domainType=200`
                    : '/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false&domainType=200'
        axiosUploadExt({
            url: url,
            method: 'post',
            headers: {
                'Content-Type': 'text/plain'
            },
            data: strObj.serveSrc
        }).then(res => {
            toastTips.clear();
            if (res.code !== 1) {
                Toast.fail(res.msg);
                this.isUploadFail(this.credentialsData.key, key)
                return
            }
            this.$emit('srcValue',{
                credentialsKey:this.credentialsData.key,
                credentialsListKey:key,
                data:res.data,
                pageSrc:strObj.pageSrc
            })
        }).catch((err) => {
            toastTips.clear();
            this.isUploadFail(this.credentialsData.key, key)
            Toast.fail('上传失败，请重新上传');
        })
      }
  }
}
</script>
<style lang='less' scoped>
.credentialsCard_ocrFail{
  // border: 3px solid #ff0000;
  // border-radius: 12px;

  /deep/ .item-img {
    border: 3px solid #ff0000;
  }
}
.card_tips{
 width: 646px;
 min-height: 58px;
 margin: 0 auto;
 background: #F7F7F7;
 border-radius: 4px;
 font-size: 28px;
 color: #7D7D80;
 padding: 0px 10px;
 display: flex;
 justify-content: center;
 align-items: center;
 margin-top:34px;
 img{
     width: 26px;
     height: 26px;
     margin-right: 10px;
     margin-top:4px
 }
}
.card_tips_success{
  background: #FFF4E1;
  color: #F27315;
}
.credentialsCard{
    // padding-bottom: 24px;
    background: #fff;
    // border-top-left-radius: 14px;
    // border-top-right-radius: 14px;
    .top{
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .top-name{
        font-family: PingFangSC-Medium;
        font-size: 32px;
        color: rgba(0,0,0,0.90);
        line-height: 48px;
        margin-left: 24px;
        font-weight: bold;
    }
    // .top-name::before{
    //   content: '';
    //   width: 6px;
    //   height: 26px;
    //   display: inline-block;
    //   vertical-align: -1px;
    //   background: #47526D ;
    //   margin-right: 4px;
    // }
    .top-tips{
        display: flex;
        align-items: center;
    }
    .top-tips-img{
        width: 26px;
        height: 26px;
        margin-right:6px;
        border-radius: 50%;
    }
    .top-tips-text{
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #47506A;
        letter-spacing: 0;
        text-decoration:underline;
        margin-right: 24.5px;
    }
    .center{
        height: 1px;
        background: rgba(0,0,0,0.06);
    }
    .bottom{
        display: flex;
        justify-content: space-around;
    }
    .electronic_bottom{
      display: flex;
      padding: 0 24px;
    }
    .bottom-item{
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: rgba(0,0,0,0.90);
        line-height: 33px;
        margin-top:26px;
        position: relative;
    }
    .bottom-item-text{
        font-size: 24px;
        color: rgba(0,0,0,0.90);
        line-height: 33px;
        margin-bottom:10px;

        .tip {
          color: #ff0000;
          margin-left: 10px;
        }
    }
}
</style>
